type EnvironmentallyFriendlyProps = {
  production: any;
  nonProduction: any;
};

const environmentallyFriendly = ({
  production,
  nonProduction,
}: EnvironmentallyFriendlyProps) =>
  process.env.NODE_ENV === 'production' ? production : nonProduction;

export default environmentallyFriendly;
